import PropTypes from 'prop-types';
import {
  useMemo,
  useEffect,
  useRef,
  useState,
} from 'react';

const licencePlateEditValid = (license, partial = true) => {
  const regex = /^[? 0-9A-Z-]{0,11}$/;
  if (partial) return regex.test(license);

  const regexFull = /^((?![ -])[? 0-9A-Z-]{5,11})(?<![ -])$|^$/;
  return regexFull.test(license);
};

function LicencePlateInput({
  style,
  className,
  country,
  licence,
  setLicence,
  sizePx = 150,
}) {
  const refInput = useRef(null);
  const [error, setError] = useState(false);

  useEffect(
    () => {
      const inputDeselected = () => {
        console.log(`input deselected, valid=${licence.valid}`);
        setError(!licence.valid);
      };

      if (refInput.current) {
        const currentInput = refInput.current;
        currentInput.addEventListener('blur', inputDeselected);

        return () => {
          currentInput.removeEventListener('blur', inputDeselected);
        };
      }

      return null;
    },
    [licence.valid],
  );

  const handleChange = (event) => {
    let { value } = event.target;
    value = value.toUpperCase();
    const valid = licencePlateEditValid(value);
    // console.log(`licence="${value}", valid=${valid}`);
    if (valid) {
      const fullValid = licencePlateEditValid(value, false);
      setLicence({
        value,
        valid: fullValid,
      });
      // In case error was outline, cancel it if input becomes ok
      if (fullValid) setError(false);
    }
  };

  const widthPx = sizePx;
  const heightPx = Math.floor(sizePx * 11 / 52);
  const fontPx = Math.floor(0.8 * heightPx);
  const radiusPx = Math.floor(sizePx / 30);
  const framePx = Math.floor(sizePx / 50);

  const backgroundColor = useMemo(
    () => {
      switch (country) {
        case 'fr': return '#FFFFFF';
        case 'lu': return '#FBBC01';
        case 'uk': return '#F8EB3E';
        default: return '#FFFFFF';
      }
    },
    [country],
  );

  const frameColor = useMemo(
    () => {
      if (error) return '#FF000080';

      switch (country) {
        case 'be': return '#E00000';
        // case 'fr': return '#000000';
        // case 'lu': return '#000000';
        case 'uk': return '#F8EB3E';
        default: return '#000000';
      }
    },
    [error, country],
  );

  const textColor = useMemo(
    () => {
      switch (country) {
        case 'be': return '#E00000';
        // case 'fr': return '#000000';
        // case 'lu': return '#000000';
        // case 'uk': return '#000000';
        default: return '#000000';
      }
    },
    [country],
  );

  return (
    <div
      className={`flex justify-center items-center relative px-1.5 ${className || ''}`}
      style={{
        height: `${heightPx}px`,
        minHeight: `${heightPx}px`,
        minWidth: `${widthPx}px`,
        border: `${framePx}px solid ${frameColor}`,
        borderRadius: `${radiusPx}px`,
        backgroundColor,
        ...style,
      }}
    >
      <input
        ref={refInput}
        type="text"
        value={licence.value}
        onChange={handleChange}
        className="w-full text-center outline-none border-none"
        style={{
          height: 'auto',
          verticalAlign: 'middle',
          color: textColor,
          backgroundColor,
          fontFamily: 'Courier New',
          fontSize: `${fontPx}px`,
          fontWeight: 700, // bold
        }}
      />
    </div>
  );
}

LicencePlateInput.propTypes = {
  style: PropTypes.shape({ }),
  className: PropTypes.string,
  country: PropTypes.string,
  licence: PropTypes.shape({
    value: PropTypes.string.isRequired,
    valid: PropTypes.bool.isRequired,
  }).isRequired,
  setLicence: PropTypes.func.isRequired,
  sizePx: PropTypes.number,
};

export default LicencePlateInput;
